import {Injectable, Injector} from '@angular/core';
import {Headers, Http, RequestOptions, Response, ResponseOptions} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {AccessReference} from '../models/access-reference.model';
import {Location} from '@angular/common';
import {Utilities} from '../utilities/utilities.model';
import {AppConfigEnvironmentService} from '@shared/service/appconfig-environment.service';
import {AppConfigEnvironment} from '@shared/models/appconfig-environment.model';
import {Router} from '@angular/router';
import {map} from 'rxjs/operators';
import {HttpClient, HttpResponse} from '@angular/common/http';

@Injectable()
export class LoginRequestService {
	public static env: AppConfigEnvironment;
	public static httpService: Http;
	public environment: AppConfigEnvironment;
	metadata: any;
    
	private static getParamsLoginOAM() {
        return {    
            'client_id'        : LoginRequestService.env.PARAMS_LOGIN_OAM_CLIENT_ID,
            'secret'           : LoginRequestService.env.PARAMS_LOGIN_OAM_SECRET,
            'domain'           : LoginRequestService.env.PARAMS_LOGIN_OAM_DOMAIN,
            'scope'            : LoginRequestService.env.PARAMS_LOGIN_OAM_SCOPE,
            'subscription_key' : LoginRequestService.env.ALD_SUBSCRIPTION_KEY,
        };
    }
    
	public static logout(callback?: Function) {

		// Dopo il logout dobbiamo fare il redirect verso il Logout di OAM
		// Loro invalideranno la sessione e reindirizzeranno verso NEMO
		const redirectToLogoutOAM = () => window.location.href = LoginRequestService.env.REDIRECT_LOGOUT_OAM;

		const { access_token, refresh_token } = Utilities.getAccessReference() ? Utilities.getAccessReference() : null;

		// Se mancano i token, fare direttamente il redirect senza revoke
		if (Utilities.isEmpty(access_token) || Utilities.isEmpty(refresh_token)) {
				redirectToLogoutOAM();
				return;
		}

		LoginRequestService.deleteAccessReference();
		LoginRequestService.deleteMetadata();
		LoginRequestService.deleteCookies();
		sessionStorage.clear();

		if (LoginRequestService.env.environment === 'local') {
			// window.location.href = LoginRequestService.env.APP_ROOT;
			location.reload();
			return;
		}   

		// Revoca del token prima del redirect verso OAM / callback
		// In locale non può entrare...
		LoginRequestService.revokeToken(
				access_token,   
				refresh_token, 
				() => callback ? callback() : redirectToLogoutOAM()
		);
	}
    
    static async revokeToken(accessToken: string, refreshToken: string, callback?: Function) {
        
        if (!Utilities.isEmpty(accessToken) && !Utilities.isEmpty(refreshToken)) {
            
            const do_revoke = async (url_params: any, options: RequestOptions) => {

                const url = LoginRequestService.env.EXTERNAL_API_LEASEPLAN_TOKEN + '/revoke' + Utilities.getQuery(url_params);
                return await LoginRequestService.httpService.post(url, null, options).toPromise().catch(e => console.error(e));
            };
            
            const header_params = {
                'Content-type'                : 'application/x-www-form-urlencoded',
                'X-OAUTH-IDENTITY-DOMAIN-NAME': LoginRequestService.getParamsLoginOAM().domain, // LPIdentityDomain
                'Authorization'               : 'Basic ' + btoa(LoginRequestService.getParamsLoginOAM().client_id + ':' + LoginRequestService.getParamsLoginOAM().secret),
                'x-ALD-subscription-key'      : LoginRequestService.getParamsLoginOAM().subscription_key,
            };
            const options = new RequestOptions();
            options.headers = new Headers();
            Object.keys(header_params).forEach(x => options.headers.set(x, header_params[x]));  


            // revoca del REFRESH TOKEN
            const url_params_revoke_efresh_token = {
                'token'          : refreshToken,
                'chaining_value' : 'RELATED_CONSENT',
                'token_type'     : EGrantTypeLoginOAM.REFRESH_TOKEN,
            };
            await do_revoke(url_params_revoke_efresh_token, options);
            
            // SOLO SERVER SIDE
            // revoca del ACCESS TOKEN
            const url_params_revoke_access_token = {
                'token'          : accessToken,
                'chaining_value' : 'RELATED_CONSENT',
                'token_type'     : EGrantTypeLoginOAM.ACCESS_TOKEN,
            };
            await do_revoke(url_params_revoke_access_token, options);

            callback ? callback() : null;
        }
	}
  
	static async redirectToLoginOAM() {

			// DA TENERE
			// if (!Utilities.isVoid(response) && response.status === 200) {
			//     LoginRequestService.setAccessReference(response.json());
			// }

			// Redirect verso il login di OAM
			
			// L'URL viene salvato nel localstorage prima del login verso OAM
			// perché LeasePlan non prende l'URL dinamico, per tivi di sicurezza

			const redirectURL = ((): string => {
				
				// l'URL dev'essere per forza relativo
				// this.location.path() non funziona quì dentro
				// bisogna farla a mano, perché è una funzione statica

				const url = document.URL;  
				const pivot = '#/';	
				
				// dev'essere un URL interno a NEMO
				if (url.startsWith(LoginRequestService.env.APP_ROOT)) {
  				const pos = url.indexOf('#');
					return (pos > -1) ? url.substring(pos+pivot.length, url.length) : '';
				}
				return '';
			})();

			localStorage.setItem('redirect_uri', redirectURL);
			
			const params = {
					'response_type' : 'code',
					'client_id'     : LoginRequestService.getParamsLoginOAM().client_id,
					'domain'        : LoginRequestService.getParamsLoginOAM().domain,
					'scope'         : LoginRequestService.getParamsLoginOAM().scope,
					'redirect_uri'  : LoginRequestService.env.APP_ROOT,

					// redirect dinamico - non si può fare per motivi di sicurezza LeasePlan 
					// 'redirect_uri'  : document.URL,
			};
			window.location.href = LoginRequestService.env.EXTERNAL_API_LEASEPLAN_AUTH + Utilities.getQuery(params);
	}
    
	public static deleteAccessReference() {
        //rimuovo dal local Storage le reference per effettuare il login
        localStorage.removeItem(Utilities.ACCESS_REFERENCE);
		sessionStorage.removeItem(Utilities.ACCESS_REFERENCE);
	}

	public static setAccessReference(accessReferenceData: any) {
			const accessReference: AccessReference = accessReferenceData as AccessReference;
			if (accessReference && accessReference.access_token) {
					//salvo le reference  nel local storage per tenere utente loggato nel refresh delle pagine
					localStorage.setItem(Utilities.ACCESS_REFERENCE, JSON.stringify(accessReferenceData));
			}
	}

	public static deleteMetadata() {
			localStorage.removeItem(Utilities.METADATA);
	}

	public static deleteCookies() {
			document.cookie = '';
	}

	public static setMetadata(metadata: any) {
			if (!Utilities.isVoid(metadata)) {
		if (!Utilities.isVoid(metadata.cod_plate)) {
							metadata.cod_plate = metadata.cod_plate.toString().trim();
					}
					localStorage.setItem(Utilities.METADATA, JSON.stringify(metadata));
			}
	}

	constructor(
			public http: Http,
			private httpClient: HttpClient,
			public router: Router,
			private appConfig: AppConfigEnvironmentService,
			public location: Location,
	) {
			LoginRequestService.env = this.appConfig.Environment;
			LoginRequestService.httpService = http;
			this.environment = this.appConfig.Environment;
	}

	loginCodeRequest(redirectUri: string, redirectToLoginPage?: boolean) {
			
	const path: string = this.location.path();
	if (path && path.length > 0) {
		localStorage.setItem(Utilities.CURRENT_ROUTE, path);
	}
			
			// AS-IS, in locale "sembrerebbe" bastare cancellare l'access_reference...
	if (this.environment.environment === 'local') {
					LoginRequestService.deleteAccessReference();
					return;
			}
			
			// # STEP 1
			// Redirect verso la JSP di Login OAM
			LoginRequestService.redirectToLoginOAM();
	}
	
	// Richiesta token accessReference per il primo login dell'APP
	loginTokensRequestOAM(redirectUri: string, auth_code: string): Observable<any> {

			// Non si può testare in locale, dato che incolliamo l'accessReference dagli ambienti remoto
			
			// OAM Login - STEP 2
			// Gestiamo il redirect a noi, da parte di OAM, e prendiamo l'auth_code
			// Abbiamo preso l'auth_code dal redirect di OAM

			try {
					// OAM Login - STEP 3
					// A questo punto richiedo i token tramite AUTHORIZATION_CODE

					const params = {
							'grant_type'    : EGrantTypeLoginOAM.AUTHORIZATION_CODE,
							'code'          : auth_code,
							'redirect_uri'  : this.environment.APP_ROOT,
					};
					return this.getAccessToken(params);

			} catch (e) {
					console.error(e);
			}

			return null;
	}

	// Refresh token, che scade dopo 1 ora circa
	loginRefreshingTokenRequest(): Observable<any> {

		// Da locale non funziona perché OAM non autorizza da localhost e va in 401
		if (this.environment.environment !== 'local') {
			try {
				const params = {
					'grant_type'    : EGrantTypeLoginOAM.REFRESH_TOKEN,
					'refresh_token' : Utilities.getAccessReference().refresh_token,
				};
				return this.getAccessToken(params);
				
			} catch (e) {
				console.error(e);
			}
		}
			
		// Va direttamente sulla pagina logout NEMO e ripreso l'accessToken da remoto
		LoginRequestService.logout();
	}

	// Non si capisce quando viene usata
	loginPasswordTokenRequest(username: string, password: string): Observable<any> {
			const params = {
					'grant_type' : EGrantTypeLoginOAM.PASSWORD,
					'username'   : username,
					'password'   : password,
			};
			return this.getAccessToken(params);
	}

	setMetadataFromAuth(sessionMetadataToken: string, refreshToken: string, accessToken: string) {
			const url = this.environment.EXTERNAL_AUTH_API + '/sessionmetadata/' + sessionMetadataToken + '?refresh_token=' + refreshToken;
			const options = new RequestOptions();
			options.headers = new Headers();
			options.headers.set('Content-Type', 'application/json');
			const bearer: string = 'Bearer ' + accessToken;
			options.headers.delete('Authorization');
			options.headers.append('Authorization', bearer);

			return new Observable<any>(
					observer => {
							this.http.get(url, options).subscribe((response) => {
									if (!Utilities.isVoid(response) && response.status === 200) {
											LoginRequestService.setMetadata(response.json().metadata);
											observer.next(response);
									} else {
											observer.next(response);
									}
							},
									e => {
											observer.error(e);
									}
							);
					});

	}

	private getAccessToken(params: object): Observable<Response> {

		// OAM Login - STEP 3
		// Si richiede l'access_token direttamente a OAM
		// in caso positivo viene salvato come $access_refence nel Local Storage

		const header_params = {
				'Content-type'                : 'application/x-www-form-urlencoded',
				'X-OAUTH-IDENTITY-DOMAIN-NAME': LoginRequestService.getParamsLoginOAM().domain,
				'Authorization'               : 'Basic ' + btoa(LoginRequestService.getParamsLoginOAM().client_id + ':' + LoginRequestService.getParamsLoginOAM().secret),
				'x-ALD-subscription-key'      : LoginRequestService.getParamsLoginOAM().subscription_key,
		};
		const options = new RequestOptions();
		options.headers = new Headers();
		Object.keys(header_params).forEach(x => options.headers.set(x, header_params[x]));

		const url = this.environment.EXTERNAL_API_LEASEPLAN_TOKEN + Utilities.getQuery(params);

		return new Observable<any>(
			observer => {
				this.http.post(url, null, options).subscribe(
					response => {
						if (!Utilities.isVoid(response) && response.status === 200) {

								const accessReference = Utilities.getAccessReference();
								
								LoginRequestService.setAccessReference({ 
										// OAM non restituisce il refresh_token 
										// dobbiamo recuperarlo dall'accessReference iniziale
										refresh_token: !Utilities.isEmpty(accessReference) ? accessReference.refresh_token : null,
										...response.json(), 
									});
						}
						observer.next(response);
					},
					e => {
						observer.error(e);
						LoginRequestService.logout();
					});
		  });
	}

	externalLoginFromTokenMetadata(tokenMetadata: string): Observable<Response> {
		const url: string = this.environment.EXTERNAL_AUTH_API + `/tokens-metadata/${tokenMetadata}`;
		return this.httpClient.post<ExternalLoginResponse>(url, {
			client_id: this.environment.clientID,
			client_secret: this.environment.clientSecret
		}, {observe: 'response'}).pipe(map((resp: HttpResponse<ExternalLoginResponse>) => {
			if (resp.ok && resp.body && resp.body.oauth_data) {
				LoginRequestService.setAccessReference(resp.body.oauth_data);
				LoginRequestService.setMetadata(resp.body.token_data.metadata);
				if (resp.body.token_data.metadata.redirect_url) {
					this.router.navigate([''], {queryParams: {redirect_url: resp.body.token_data.metadata.redirect_url}});
				}
			}
			return new Response(new ResponseOptions({
				body: resp.body,
				status: resp.status
			}));
		}));
	}
}

export interface ExternalLoginResponse {
	oauth_data: AccessReference;
	token_data: Tokendata;
}

export interface Tokendata {
	user_id: string;
	email: string;
	initial_number_of_uses: number;
	remaining_number_of_uses: number;
	expires_in: number;
	metadata: any;
}

enum EGrantTypeLoginOAM {
    'AUTHORIZATION_CODE' = 'AUTHORIZATION_CODE',
    'ACCESS_TOKEN'       = 'ACCESS_TOKEN',
    'REFRESH_TOKEN'      = 'REFRESH_TOKEN',
    'PASSWORD'           = 'PASSWORD',
}